import RestClient from '../api/restClient';
import foldersApi from '../api/foldersApi';

class FoldersService {
  addConversationToFolder(conversationId, folderId, isGroup, isInboxRetention) {
    return foldersApi.addConversationToFolder(conversationId, folderId, isGroup, isInboxRetention);
  }

  removeConversationFromFolder(conversationId, folderId, isGroup) {
    return foldersApi.removeConversationFromFolder(conversationId, folderId, isGroup);
  }

  addOrRemoveSinggleConversationToMultipleFolder(conversationId, folders) {
    return foldersApi.addOrRemoveSinggleConversationToMultipleFolder(conversationId, folders);
  }

  getFolders(params) {
    return foldersApi.getFolders(params);
  }

  createFolder(params) {
    return foldersApi.createFolder(params);
  }

  updateFolder(id, params) {
    return foldersApi.updateFolder(id, params);
  }

  deleteFolder(id) {
    return foldersApi.deleteFolder(id);
  }
}

export default new FoldersService();
